export default __webpack_public_path__ + "static/media/Autokritigallery_9.51cf18bb.jpg";